export function processAccordians(base = document) {
    base.querySelectorAll('.wp-block-smarttouch-accordian-row').forEach(block=>{
        block.querySelector('.head').addEventListener('click',()=>{
            if(block.ariaExpanded=='true') {
                block.ariaExpanded='false';
                block.lastChild.style.height = 0;
            } else {
                block.ariaExpanded='true';
                block.lastChild.style.height = block.lastChild.firstChild.offsetHeight + 'px';
                if(block.parentNode.classList.contains('collapse-siblings')) {
                    block.parentNode.querySelectorAll('.wp-block-smarttouch-accordian-row').forEach(el=>{
                        if(el!=block) {
                            el.ariaExpanded='false';
                            el.lastChild.style.height = 0;
                        }
                    });
                }
            }
		});
		if(block.ariaExpanded=='true') {
			block.lastChild.classList.add('init');
			block.lastChild.style.height = block.lastChild.firstChild.offsetHeight + 'px';
			setTimeout(()=>{block.lastChild.classList.remove('init');},100);
		}
    });
}